module.exports = __webpack_public_path__ + "img/guarantee-adviser.3cff6089.png";